import { Component, OnDestroy, OnInit } from '@angular/core';
import { HwwHelpService, SchemaButton } from '../../hww-help.service';
import { Subject, takeUntil } from 'rxjs';
import {
  defaultHWWData,
  excludedKeys,
  hwwMethodSteps,
  healthIndexData,
  wealthIndexData,
  wisdomIndexData,
} from '../textStorage';
import { MatDivider } from '@angular/material/divider';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { SeoService } from '../../../../../seo/seo.service';
import { hwwPageTags } from '../../../../../shared/util/seo-tags';

export interface TextContent {
  key: string;
  value: string;
}

@Component({
  selector: 'app-hww-content',
  templateUrl: './hww-content.component.html',
  styleUrls: ['./hww-content.component.scss'],
  imports: [
    NgFor,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgClass,
    NgIf,
    MatDivider,
  ],
})
export class HwwContentComponent implements OnInit, OnDestroy {
  public SchemaButton = SchemaButton;
  public readonly methodSteps = hwwMethodSteps;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  public pageTitle!: string;
  public pageFooter!: string;
  public pageHead!: string;
  public pageAbout!: string;

  public activeTertiaryButtons!: string[];

  public contentsArray: TextContent[] = [];

  constructor(
    private hwwService: HwwHelpService,
    private seo: SeoService
  ) {}

  ngOnInit(): void {
    this.seo.applyPageSeo(hwwPageTags);
    this.handleSubscriptions();
    this.activeTertiaryButtons = this.hwwService.activeTertiaryButtons;

    this.parseTextObject(defaultHWWData);
  }

  private handleSubscriptions(): void {
    this.hwwService.activeButton
      .pipe(takeUntil(this.destroy$))
      .subscribe((button) => {
        if (button === SchemaButton.PRIMARY) {
          this.parseTextObject(defaultHWWData);
        }
        if (button === SchemaButton.LEFT) {
          this.parseTextObject(healthIndexData);
        }
        if (button === SchemaButton.MIDDLE) {
          this.parseTextObject(wealthIndexData);
        }
        if (button === SchemaButton.RIGHT) {
          this.parseTextObject(wisdomIndexData);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public handleLinkButtonsClick(button: SchemaButton): void {
    this.hwwService.activeButton.next(button);
  }

  public handleExpansionPanelClick(key: string): void {
    if (this.activeTertiaryButtons.includes(key)) {
      const index = this.activeTertiaryButtons.indexOf(key);
      this.activeTertiaryButtons.splice(index, 1);
    } else {
      this.activeTertiaryButtons.push(key);
    }
  }

  public getActiveIndex(): SchemaButton {
    return this.hwwService.activeButton.getValue();
  }

  private parseTextObject(data: { [key: string]: string }): void {
    this.pageTitle = data.title ?? '';
    this.pageFooter = data.footer ?? '';
    this.pageHead = data.head ?? '';
    this.pageAbout = data.about ?? '';

    this.contentsArray = Object.entries(data)
      .filter(([key, value]) => !excludedKeys.includes(key))
      .map(([key, value]) => {
        return {
          key: key,
          value: value,
        };
      });
  }
}
